// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"9c107c8c","640":"31d6cfe0","908":"9c107c8c","940":"9b6f4831"}[chunkId] + ".chunk.css";
};